import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, CadastrarParametroLocalidade } from './types';

export const INITIAL_STATE: CadastrarParametroLocalidade = {
	status: 0,
	data: null,
};

export default function cadastrarParametroLocalidadeReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarParametroLocalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_PARAMETRO_LOCALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_LOCALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_LOCALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_LOCALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
